import {
  Box,
  Button,
  Modal,
  Slide,
  Typography,
  Stack,
  Avatar,
  SxProps,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useEffect, useState } from 'react';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IStyles } from '../../../commonUtils/styleUtils';
import ImageWrapper from '../../elements/ImageWrapper';
const styles: IStyles = {
  root: {},

  containerBox: {
    border: '1px solid #C9E5D7',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    // padding: '8px 16px',
    padding: { xs: pxToRem(6), md: pxTovW(9) },
    gap: 1,
    backgroundColor: '#F9FFFB',
    width: { sm: pxToRem(220), md: pxTovW(250) },
    // height: { sm: pxToRem(70), md: pxTovW(68) },
  },
  iconContainer: {
    backgroundColor: '#E3F8EC',
    paddingX: { xs: pxToRem(10), md: pxTovW(10) },
    paddingY: { xs: pxToRem(5), md: pxTovW(5) },
    marginRight: { xs: pxToRem(5), md: pxTovW(8) },
    borderRadius: { xs: pxToRem(5), md: pxTovW(5) },
  },
  iconwarp: {
    width: { sm: pxToRem(25), md: pxTovW(30) },
    height: { sm: pxToRem(40), md: pxTovW(45) },
    borderRadius: pxToRem(5),
    margin: 'auto',
  },
  lables: {
    fontSize: { sm: pxToRem(20), md: pxTovW(22) },
    fontWeight: 'bold',
  },
};
type ValueType = 'mobile-app' | 'clicker';
interface BtnIcon {
  id: ValueType;
  image: ValueType;
  label: string;
}

const btnIcons: BtnIcon[] = [
  {
    id: 'mobile-app',
    image: 'mobile-app', //icon name
    label: 'Geneo App',
  },
  {
    id: 'clicker',
    image: 'clicker', //icon name
    label: 'Geneo Clicker',
  },
];
interface ConductionButtonsProps {
  value: ValueType;
  onChange: (value: ValueType) => void;
  customCSS?: SxProps;
  direction?: 'row' | 'column'; // 👈 new prop
}
export const ConductionButtonsComponent = ({
  value,
  onChange,
  customCSS,
  direction,
}: ConductionButtonsProps) => {
  const [selected, setSelected] = useState<ValueType>(value);

  const selectOption = (val: ValueType) => {
    onChange(val);
    setSelected(val);
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontWeight: 'bold',
          marginBottom: pxToRem(20),
        }}
      >
        Choose Mode of Conduction
      </Typography>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          paddingBottom: { xs: pxToRem(10), md: pxTovW(10) },
        }}
      >
        <Stack
          direction={direction || { xs: 'column', md: 'row' }} // 👈 dynamic direction
          // flexWrap={{ xs: 'wrap' }} // optional: allows wrap in small screens
          justifyContent="center"
          alignItems="center"
          spacing={2}
          // useFlexGap
          sx={{
            maxWidth: '100%',
            width: { xs: '100%', sm: 'auto' },
            ...customCSS,
          }}
        >
          {/* Geneo App Option */}
          {btnIcons.map((item) => (
            <Box
              sx={{
                display: 'flex',
                // flexDirection: 'row',
                alignItems: 'center',
                cursor: 'pointer',
                minWidth: { xs: '140px', sm: '180px' },
              }}
              onClick={() => selectOption(item.image)}
            >
              <Box sx={{ width: '30px' }}>
                <CheckCircleIcon
                  sx={{
                    color: '#00C853',

                    display: item.id === selected ? 'inline-flex' : 'none',
                  }}
                />
              </Box>

              <Box sx={styles.containerBox}>
                <Box sx={styles.iconContainer}>
                  <ImageWrapper
                    name={item.image}
                    type="png"
                    parentFolder="icons"
                    styles={styles.iconwarp}
                  />
                </Box>
                <Typography sx={styles.lables}> {item.label}</Typography>
              </Box>
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};
